module.exports = __webpack_public_path__ + "assets/img/03-f44115b1.jpg";